import { Grid, TableRow } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import {
  BlastRadiusCell,
  ImpactCell,
  PublishedCell,
  RiskFactorsCell,
  TitleCell,
} from "~/components/Cells";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { ScoreRating } from "~/operations";
import { ReportsNoItemsSection } from "../../components";
import { spacing } from "~/pages/reports/utils/reportsConstants";
import { useChecksOrVulnerabilitiesReport } from "../hooks/useChecksOrVulnerabilities";
import { ReportType } from "~/reportApp/reportingApp";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

export function ChecksReportsTable() {
  const { failingChecks } = useChecksOrVulnerabilitiesReport({
    reportType: ReportType.Checks,
  });

  return (
    <Fragment>
      <Grid size={12} sx={{ mb: spacing[50] }}>
        {[failingChecks].map((group) => {
          if (!group) return null;
          return (
            <Fragment>
              <ReportsSectionHeading
                heading={group.heading}
                dividerContent={`${group.total} Total`}
              />
              <Grid size={12} sx={{ my: 3 }}>
                {false ? (
                  <ReportsNoItemsSection target="Checks" />
                ) : (
                  <GenericTable
                    items={0}
                    tableName="CHECKS_REPORT_CHECKS"
                    validSortFields={[]}
                    printView
                  >
                    {group.items?.map((check, index) => {
                      const {
                        id,
                        riskValue,
                        rating,
                        title,
                        tags,
                        riskFactors,
                        blastRadius,
                        lastScannedAt,
                      } = check.node || {};

                      return (
                        <TableRow key={id}>
                          <ImpactCell
                            impact={riskValue || 0}
                            rating={rating || ScoreRating.Critical}
                            isActive={rating == null ? false : true}
                            hideTooltip
                          />
                          <BlastRadiusCell
                            blastRadius={blastRadius}
                            impact={riskValue || 0}
                            rating={rating || ScoreRating.Unscored}
                            isActive={rating == null ? false : true}
                          />

                          <TitleCell
                            title={title || ""}
                            tags={tags}
                            options={{ fontSize: 14 }}
                          />
                          <RiskFactorsCell
                            riskFactors={riskFactors}
                            printView
                          />
                          <PublishedCell date={lastScannedAt || "Never"} />
                        </TableRow>
                      );
                    })}
                  </GenericTable>
                )}
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </Fragment>
  );
}
